import InfoBox from 'components/InfoBox';
import Text from 'components/base/Text';

const NewCustomFieldInfo = () => {
  return (
    <InfoBox
      mt={null}
      mb='small'
      icon='alert'
      iconAlign='center'
      iconColor='orangePeel'
      backgroundColor='orangePeel'
      backgroundAlpha={0.1}
      borderColor='orangePeel'
      borderAlpha={0.2}
      width='fit-content'
    >
      <Text size='medium' pl='0.5rem' weight='400'>
        It may take some time to present new data
      </Text>
    </InfoBox>
  );
};

export default NewCustomFieldInfo;
